import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";

import TimelapseOutlined from "@material-ui/icons/TimelapseOutlined";
import CheckCircle from "@material-ui/icons/CheckCircle";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";

import { actions as sliderSidebarActions } from "Portal/NewPortal/Sections/Sessions/FlyOver/model";

import { connect } from "react-redux";

import { noop } from "utils/General";
import { getVisibleSessionFieldIds } from "Portal/NewPortal/PortalHome/selectors";
import * as FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";

export const StatusComponent = ({ status, className }) =>
  R.propOr(
    <CheckCircle className={className} style={{ color: "#51CF66" }} />,
    status,
    {
      approved: (
        <CheckCircle className={className} style={{ color: "#51CF66" }} />
      ),
      pending: (
        <TimelapseOutlined className={className} style={{ color: "#FF922B" }} />
      ),
      rejected: (
        <FiberManualRecordOutlinedIcon
          className={className}
          style={{ color: "#FF6B6B" }}
        />
      ),
      declined: (
        <FiberManualRecordOutlinedIcon
          className={className}
          style={{ color: "#FF6B6B" }}
        />
      ),
      null: <>-</>
    }
  );

const decorate = R.compose(
  connect(
    state => ({
      visibleSessionFieldIds: getVisibleSessionFieldIds(state)
    }),
    {
      openSessionFlyover: sliderSidebarActions.openSessionFlyover
    }
  ),
  CSSModules(css)
);

const Session = data => {
  const {
    visibleSessionFieldIds,
    status,
    name,
    open_label,
    // is_past_due,
    meta = {},
    isSubsession,
    // isReadOnly,
    parentStatus,
    openSessionFlyover = noop
  } = data;

  const { date, location } = meta;

  const hideDataUpponStatus =
    parentStatus === "rejected" || parentStatus === "pending";

  const isDateVisible =
    visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.STARTS_AT) &&
    visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.ENDS_AT);
  const isLocationVisible = visibleSessionFieldIds.includes(
    FIELD_IDS.SESSIONS.LOCATION
  );

  return (
    <div
      className={[css.sessionContainer, "accentable-hover"].join(" ")}
      style={isSubsession ? { width: "90%" } : {}}
      onClick={() => {
        openSessionFlyover({ sessionData: data, fromHomePage: true });
      }}
    >
      <div className={css.sessionContent}>
        <div className={css.sessionHeader}>
          <div className={css.sessionTitle}>{name}</div>
        </div>
        <div className={css.sessionStatusContainer}>
          <div className={css.sessionStatus}>
            <div className={css.statusIcon}>
              <StatusComponent
                className={css.statusIndicator}
                status={status}
              />
            </div>
            <div className={css.statusText}>{open_label}</div>
          </div>
          {(isDateVisible && date && !hideDataUpponStatus) ||
          (isLocationVisible && location) ? (
            <div className={css.sessionDetails}>
              <div className={css.calendarIcon}>
                <CalendarTodayOutlinedIcon
                  style={{ fontSize: "14px", color: "#666666" }}
                />
              </div>
              <div className={css.detailsText}>
                {isDateVisible && date
                  ? date.replace(/(st)|(th)|(nd)|(rd)/, "")
                  : null}
                {isDateVisible && date && isLocationVisible && location ? (
                  <>&nbsp;|&nbsp;</>
                ) : null}
                {isLocationVisible && location ? location : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default decorate(Session);
